import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from '@/store';
import fb from '@/firebaseConfig';
import dbx from '@/dropboxConfig';
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false;

Vue.use(VueCookies);
//TODO: Vue.$cookies.config('', '', '', true);

let app;
let unsubscribeUsers;

fb.auth.onAuthStateChanged((fbUser) => {
  // TODO: Is there a beter place to put this?
  store.watch(
    (state, getters) => getters['user/user'].details.dbx_token,
    (newValue) => {
      if (newValue) {
        dbx.setAccessToken(newValue);
        store.dispatch('dropbox/fetchUserProfile');
        store.dispatch('dropbox/fetchStructure');
      } else {
        console.log('Clearing dropbox state...');
        dbx.setAccessToken(null);
        store.dispatch('dropbox/clearState');
      }
    }
  );

  if (fbUser) {
    unsubscribeUsers = fb.db
      .collection('users')
      .doc(fbUser.uid)
      .onSnapshot(() => {
        if (fbUser) {
          store.dispatch('user/fetchUserProfile', fbUser);
        }
      });
    store.dispatch('assets/fetchAssets', fbUser);
  } else {
    if (unsubscribeUsers) {
      unsubscribeUsers();
    }
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  }
});
